import enviro from 'enviro';
import { createTracker } from 'usage-tracker';
import { withSessionReplay } from 'usage-tracker-session-replay';
import Raven from 'raven-js';
import eventDefinitions from '../events.yaml';
import { entriesOf } from './utils/common';
const DEFAULT_TRACKER_PROPS = {
  events: eventDefinitions,
  properties: {
    namespace: 'commerce-billing'
  },
  onError: err => {
    Raven.captureMessage('commerce-billing-lib tracker event error', {
      stacktrace: true,
      extra: {
        message: err.message
      }
    });
  }
};
export const tracker = createTracker(DEFAULT_TRACKER_PROPS);
export const trackerWithSessionReplay = withSessionReplay(tracker, {
  sampleRate: 0.01
});
export function interaction(action) {
  return value => {
    var _value, _value$toString;
    if (typeof value === 'object') {
      value = undefined;
    }
    value = (_value = value) === null || _value === void 0 || (_value$toString = _value.toString) === null || _value$toString === void 0 ? void 0 : _value$toString.call(_value);
    if (enviro.isQa()) {
      /* eslint-disable-next-line no-console */
      console.log(value ? `interaction = "${action}", value = "${value}"` : `interaction = "${action}"`);
    }
    trackerWithSessionReplay.track('interactionEvent', {
      action,
      value
    });
  };
}

// track all the stuff users interact with
export const staticEvents = Object.freeze({
  contact: {
    select: 'click:contact/select',
    selected: 'click:contact/select/selectedExistingContact',
    edit: 'click:contact/edit',
    editFirstname: 'click:contact/edit/firstname',
    editLastname: 'click:contact/edit/lastname',
    editEmail: 'click:contact/edit/email',
    editJobtitle: 'click:contact/edit/jobtitle',
    editPhone: 'click:contact/edit/phone',
    editSubmit: 'click:contact/edit/submit',
    editCancel: 'click:contact/edit/cancel',
    addExisting: 'click:contact/addExisting',
    createNew: 'click:contact/createNew',
    createNewFirstname: 'click:contact/createNew/firstname',
    createNewLastname: 'click:contact/createNew/lastname',
    createNewEmail: 'click:contact/createNew/email',
    createNewJobtitle: 'click:contact/createNew/jobtitle',
    createNewPhone: 'click:contact/createNew/phone',
    createNewSubmit: 'click:contact/createNew/submit',
    createNewCancel: 'click:contact/createNew/cancel',
    useBillingContact: 'click:confirmUseBillingContact'
  },
  company: {
    select: 'click:company/select',
    selected: 'click:company/select/selectedExistingCompany',
    removed: 'click:company/select/removedSelectedCompany',
    edit: 'click:company/edit',
    editName: 'click:company/edit/name',
    editAddress: 'click:company/edit/address',
    editAddress2: 'click:company/edit/address2',
    editState: 'click:company/edit/state',
    editCity: 'click:company/edit/city',
    editZip: 'click:company/edit/zip',
    editCountry: 'click:company/edit/country',
    editSubmit: 'click:company/edit/submit',
    editCancel: 'click:company/edit/cancel',
    addExisting: 'click:company/addExisting',
    createNew: 'click:company/createNew',
    createNewName: 'click:company/createNew/name',
    createNewAddress: 'click:company/createNew/address',
    createNewAddress2: 'click:company/createNew/address2',
    createNewState: 'click:company/createNew/state',
    createNewCity: 'click:company/createNew/city',
    createNewZip: 'click:company/createNew/zip',
    createNewCountry: 'click:company/createNew/country',
    createNewSubmit: 'click:company/createNew/submit',
    createNewCancel: 'click:company/createNew/cancel'
  },
  billingAddress: {
    edit: 'click:billingAddress/edit',
    address: 'click:billingAddress/address',
    address2: 'click:billingAddress/address2',
    state: 'click:billingAddress/state',
    city: 'click:billingAddress/city',
    zip: 'click:billingAddress/zip',
    country: 'click:billingAddress/country',
    submit: 'click:billingAddress/submit',
    cancel: 'click:billingAddress/cancel',
    toggleUseCompanyAddress: 'toggle:billingAddress/useCompanyAddress'
  },
  lineItems: {
    editColumns: 'click:lineItems/editLineItemColumns'
  },
  checkoutSettings: {
    netTerms: 'click:checkoutSettings/netTerms',
    includeCheckoutLink: 'toggle:checkoutSettings/includeCheckoutLink',
    updatePaymentMethods: 'toggle:checkoutSettings/acceptedPaymentMethods',
    maybeChurnViaPaymentLink: 'click:checkoutSettings/maybeChurnViaPaymentLink',
    collectBillingAddress: 'toggle:checkoutSettings/collectBillingAddress',
    collectShippingAddress: 'toggle:checkoutSettings/collectShippingAddress'
  },
  advancedSettings: {
    toggle: 'click:advancedSettings',
    language: 'click:advancedSettings/language',
    locale: 'click:advancedSettings/locale',
    invoiceComments: 'click:advancedSettings/invoiceComments',
    modifyInvoiceComments: 'type:advancedSettings/modifyInvoiceComments',
    toggleAutoEmailInvoices: 'click:advancedSettings/autoEmailInvoices'
  },
  missingReadScope: 'permissions:missingSubscriptionReadScope',
  missingWriteScope: 'permissions:missingSubscriptionWriteScope',
  exit: 'click:exit',
  exitConfirm: 'click:exit/confirm',
  exitCancel: 'click:exit/cancel',
  create: 'click:create',
  createConfirm: 'click:create/confirm',
  createCancel: 'click:create/cancel',
  createChargeFailed: 'click:create/chargeFailed'
});
function toInteractions(entry) {
  if (typeof entry === 'string') {
    return interaction(entry);
  }
  if (typeof entry === 'object' && entry !== null) {
    return Object.fromEntries(entriesOf(entry).map(([key, value]) => [key, typeof value === 'string' ? interaction(value) : toInteractions(value)]));
  }
  return entry;
}
export const billWizEvents = toInteractions(staticEvents);